export default __webpack_public_path__ + "static/media/my-graphics-aca7273468f1475d02f7e4041b038fb3.png";